import React from 'react';
import { CellPlugin } from '@react-page/editor';
import LayersIcon from '@mui/icons-material/Layers';
import { ColorPickerField } from '@react-page/editor';

export interface ParallaxData extends Record<string, unknown> {
  mode?: 'parallax' | 'window';
  speed?: number;
  backgroundColor?: string;
  visibility?: 'all' | 'hide-mobile' | 'mobile-only';
}

export function createParallaxContainerPlugin(): CellPlugin<ParallaxData> {
  return {
    id: 'parallax-container',
    title: 'Parallax / Scroll Window Container',
    description: 'Wrap content with parallax or fixed window scroll effect',
    icon: <LayersIcon />,
    version: 2,

    Renderer: ({ children, data }) => {
      const isWindow = data.mode === 'window';
      const visibilityClass = data.visibility === 'hide-mobile' ? 'hide-mobile' : data.visibility === 'mobile-only' ? 'mobile-only' : '';

      return (
        <div
          className={visibilityClass}
          style={{
            position: 'relative',
            backgroundColor: data.backgroundColor ?? '#ffffff',
            height: isWindow ? '1000px' : 'auto',
            overflow: isWindow ? 'hidden' : 'visible',
            padding: isWindow ? 0 : 20,
          }}
        >
          {isWindow ? (
            <>
              {/* Fixed background layer */}
              <div
                style={{
                  position: 'fixed',
                  top: 0,
                  left: 0,
                  width: '100%',
                  height: 'auto',
                  zIndex: 0,
                  pointerEvents: 'none',
                }}
              >
                {children}
              </div>

              {/* Scrollable overlay window */}
              <div
                style={{
                  position: 'relative',
                  height: '1000px',
                  zIndex: 1,
                  pointerEvents: 'auto',
                }}
              />
            </>
          ) : (
            // Standard parallax rendering
            <div
              style={{
                willChange: 'transform',
                transition: 'transform 0.1s ease-out',
              }}
            >
              {children}
            </div>
          )}
        </div>
      );
    },


    controls: {
      type: 'autoform',
      schema: {
        type: 'object',
        required: [],
        properties: {
          mode: {
            type: 'string',
            title: 'Scroll Mode',
            enum: ['parallax', 'window'] as string[],
            default: 'parallax',
          } as any,
          speed: {
            type: 'number',
            title: 'Parallax speed (only if mode = parallax)',
            default: 0.5,
          } as any,
          backgroundColor: {
            type: 'string',
            title: 'Background Color',
            default: '#ffffff',
            uniforms: {
              component: ColorPickerField,
            },
          } as any,
          visibility: {
            type: 'string',
            title: 'Visibility',
            enum: ['all', 'hide-mobile', 'mobile-only'],
            default: 'all',
          } as any,
        },
      },
    },
  };
}
